import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: '$colorBgSurface',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowIconContainer: {
    width: 48,
    height: 48,
    borderRadius: '$borderRadiusFull',
    backgroundColor: '$colorBgBase',
  },
  rowIconSubContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowIcon: {
    height: 24,
    width: 24,
    fontSize: 24,
  },
  rowTextContainer: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowText: {
    display: 'flex',
    marginLeft: '$space4',
    flex: 1,
  },
});
